---
seo:
  title: Manage Profile
  description: Referring doctor portals
---

# **Manage Profile**

- [Edit Practice Information](#edit-practice-information)
- [Change Password](#change-password)

---

#### **Edit Practice Information**

- Click on **Manage Profile** in the Navigation Bar

![manage-profile](./assets/manage-profile.png) 

- Click **Edit Profile**

![edit-profile](./assets/edit-profile.png)

- **Edit your profile**
  - Click Submit when you are finished

![edit-profile](./assets/edit-profile.png)

---

#### **Change Password**

- Click Change Password

![change-password](./assets/change-password.png)

- Enter your old password
- Enter your new password
  - Your password can’t be too similar to your other personal information.
  - Your password must contain at least 8 characters.
  - Your password can’t be a commonly used password.
  - Your password can’t be entirely numeric.
- Confirm your new password

![password-change-form](./assets/password-change-form.png)